export default "__VITE_ASSET__6d216f50__"